import { inject, Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { httpsCallable } from 'firebase/functions';

@Injectable({
    providedIn: 'root'
})
export class BackendApiTokensService {
    private readonly functions = inject(Functions);
    private readonly getAllApiTokens = httpsCallable(this.functions, 'getAllApiTokens');
    private readonly createApiToken = httpsCallable(this.functions, 'createApiToken');
    private readonly deleteApiToken = httpsCallable(this.functions, 'deleteApiToken');

    public getAll(): Promise<any> {
        return this.getAllApiTokens();
    }

    public create(): Promise<any> {
        return this.createApiToken();
    }

    public delete(token: string): Promise<any> {
        return this.deleteApiToken({
            token
        });
    }
}
